import React, { useEffect, useLayoutEffect, useState } from "react";
import { Card, Empty, Typography as typography_antd } from "antd";
import LeaveSummaryStyle from "./LeaveSummaryStyle";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import {
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table,
  Typography,
  Paper,
} from "@mui/material";
import { fetchLeaveSummaryData } from "../../redux/slice/getLeaveSummary";
import { useDispatch, useSelector } from "react-redux";
import { fetchSubLeaveTypeData } from "../../redux/slice/subLeaveType";
import { jwtDecode } from "jwt-decode";
import { logout, setToken, setUserData } from "../../redux/slice/authSlice";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";

const { Title } = typography_antd;

const LeaveSummary = (props) => {
  const [leaveSummaryData, setLeaveSummaryData] = useState(null);

  const token = useSelector((state) => state.auth.token);
  let decode = jwtDecode(token);
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  if (state?.getLeaveSummary?.data?.status === 555 || state?.getLeaveSummary?.data?.status === 501
    || state?.getSubLeaveType?.data?.status === 555 || state?.getSubLeaveType?.data?.status === 501
  ) {
    dispatch(setToken(null));
    dispatch(setUserData(null));
    toast.error("Session expire, Please LogIn!", {
      position: toast.POSITION.TOP_RIGHT,
      toastId: "1",
    });
    Navigate("/login")
  }
  const tempLeaveSummury = state?.getLeaveSummary?.data?.data;
  const tempSubLeaveType = state?.getSubLeaveType?.data?.data;

  useEffect(() => {
    if (token) {
      dispatch(fetchSubLeaveTypeData(token));
    }
    if (decode?.id) {
      const obj = {
        id: decode?.id,
        token: token
      }
      dispatch(fetchLeaveSummaryData(obj));
    }
  }, [decode?.id]);
  useEffect(() => {
    if (tempLeaveSummury && tempSubLeaveType) {
      getLeaveSummary();
    }
  }, [state]);
  const getLeaveSummary = async () => {
    let subLeaveData = {};
    tempSubLeaveType.map((doc) => {
      subLeaveData = {
        ...subLeaveData,
        [doc?.sub_leave_type_id]: doc?.sub_leave_title,
      };
    });

    let LeaveObj = [];
    Object.keys(subLeaveData)
      .sort()
      .map((itemKey, index) => {
        LeaveObj.push({
          key: index,
          leave_type: subLeaveData[itemKey],
          day_assign: tempLeaveSummury[0]?.leave_summary[itemKey],
          day_taken:
            tempLeaveSummury[0]?.leave_summary[itemKey] -
            tempLeaveSummury[0]?.remaining_leave_summary[itemKey],
          balance: tempLeaveSummury[0]?.remaining_leave_summary[itemKey],
        });
      });
    setLeaveSummaryData(LeaveObj);
  };
  return (
    <LeaveSummaryStyle>
      <div className="site-card-border-less-wrapper">
        <Card
          bodyStyle={{ height: "calc(100vh - 75px)", padding: "10px" }}
          bordered={false}
          style={{
            margin: 10,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "left",
              marginTop: "3px",
            }}
          >
            <Title
              level={2}
              style={{ color: "#244DA0", fontFamily: "ImportedMilliardBold" }}
            >
              Leave Summary
            </Title>
          </div>

          {leaveSummaryData === null ? (
            <span class="loader"></span>
          ) : leaveSummaryData !== null ? (
            <TableContainer component={Paper} className="table-container"
              sx={{
                // maxHeight: "460px",
                borderTopLeftRadius: 15,
                borderTopRightRadius: 15,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0
              }}
            >
              <Table
                sx={{
                  minWidth: 400,
                  '& th, & td': {
                    border: '1px solid #f0f0f0',
                  },
                }}
                aria-label="simple table"
              >
                <TableHead className="table_Header_color" sx={{ height: "50px" }}>
                  <TableRow
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 1,
                      backgroundColor: "#244DA0",
                    }}>
                    <TableCell style={{ color: "white" }}>
                      Leave Type
                    </TableCell>
                    <TableCell style={{ color: "white" }}>
                      Days Assign
                    </TableCell>
                    <TableCell style={{ color: "white" }}>
                      Days Taken
                    </TableCell>
                    <TableCell style={{ color: "white" }}>
                      Leave Balance
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {leaveSummaryData?.map((row) => (
                    <TableRow
                      key={row.name}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell>{row.leave_type}</TableCell>
                      <TableCell>{row.day_assign}</TableCell>
                      <TableCell>{row.day_taken}</TableCell>
                      <TableCell>{row.balance}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <div style={{ marginTop: "15%" }}>
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </div>
          )}
        </Card>
      </div>
    </LeaveSummaryStyle>
  );
};

export default LeaveSummary;
